/**
 * 弹窗打开后取消对搜索类输入框的自动聚焦，避免触屏误弹系统键盘。
 * @param modalSelector 弹窗根节点 class 选择器（如 `.resource-picker-modal`）
 */
export function blurModalSearchFocus(modalSelector: string): void {
  const active = document.activeElement
  if (!(active instanceof HTMLElement)) return
  if (!active.closest(modalSelector)) return
  const tag = active.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA') active.blur()
}
